import { ActivityLevel } from "@/clients/models/ActivityLevel";
import IconCardSelector from "@/components/form/icon-card-selector";
import { ActivityLevelOption } from "../../hooks/use-activity-level";

interface ActivityLevelSelectionListProps {
  options: ActivityLevelOption[];
  selectedActivityLevel: ActivityLevel.activityLevel | null;
  handleActivityLevelSelect: (option: ActivityLevelOption) => () => void;
}

export default function ActivityLevelSelectionList({
  options,
  selectedActivityLevel,
  handleActivityLevelSelect,
}: ActivityLevelSelectionListProps) {
  return (
    <div className="w-full flex flex-col gap-3">
      {options.map((option) => (
        <IconCardSelector
          key={option.value}
          title={option.title}
          description={option.description}
          selected={selectedActivityLevel === option.value}
          onClick={handleActivityLevelSelect(option)}
        />
      ))}
    </div>
  );
}
